import { render } from "./request.vue?vue&type=template&id=ce8ccd9a&scoped=true"
import script from "./request.vue?vue&type=script&lang=js"
export * from "./request.vue?vue&type=script&lang=js"

import "./request.vue?vue&type=style&index=0&id=ce8ccd9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce8ccd9a"

export default script